import qs from 'query-string';
import { get } from './baseApi';

export const InvoiceApi = {
    fetch: (query) => get(`/invoices?${qs.stringify(query)}`),
};
